import { useTranslation } from '../../../../../utils/useTranslation';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { StatisticItem } from '../StatisticItem/StatisticItem';
import { StatisticSkeleton } from '../StatisticSkeleton/StatisticSkeleton';
import { StatisticContentProps } from './types';

export const StatisticContent: React.FC<StatisticContentProps> = ({
    statisticLoading,
    statistic,
}) => {
    const t = useTranslation();

    if (statisticLoading) {
        return <StatisticSkeleton />;
    }

    if (!statistic) {
        return (
            <Flex width="100%" alignItems="center">
                <Typography variant="body2" p={2}>
                    {t('Не удалось загрузить статистику')}
                </Typography>
            </Flex>
        );
    }

    const { shows, showsInGrid, subscribers, interactions } = statistic;

    return (
        <Flex
            width="100%"
            direction="row"
            alignItems="stretch"
            justifyContent="stretch"
            flexWrap="wrap"
        >
            <StatisticItem
                title={t('Показы в ленте')}
                displayValue={showsInGrid.total.display}
                diffValue={showsInGrid.total.diffValue}
                diffDisplay={showsInGrid.total.diffDisplay}
                mr={1}
            />
            <StatisticItem
                title={t('Показы с действием')}
                displayValue={shows.total.display}
                diffValue={shows.total.diffValue}
                diffDisplay={shows.total.diffDisplay}
                mr={{ xs: 0, sm: 1 }}
            />
            <StatisticItem
                title={t('Подписчики')}
                displayValue={subscribers.total.display}
                diffValue={subscribers.total.diffValue}
                diffDisplay={subscribers.total.diffDisplay}
                mr={1}
            />
            <StatisticItem
                title={t('Клики по ссылке')}
                displayValue={interactions.clicks.display}
                diffValue={interactions.clicks.diffValue}
                diffDisplay={interactions.clicks.diffDisplay}
            />
        </Flex>
    );
};
